export const APP_READY_INFO_URL_PARAM = 'appReadyInfo';
